import { useQuery } from 'react-query'
import client from '../client'

async function pmCheck() {
  const response = await client.get<{ title: string; content: string; msg1: string; msg2: string }>(
    '/api/pmcheck'
  )

  return response.data
}

export default function getPmCheckQuery() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, isLoading, isError } = useQuery<any>(getPmCheckQuery.createKey(), () => pmCheck(), {
    refetchOnWindowFocus: false,
    // staleTime: 1000 * 60 * 5,
  })
  return { data, isLoading, isError }
}

getPmCheckQuery.createKey = () => ['eventDate']
